declare global {
    interface Window {
      cspNonce?: string;
    }
  }
  
  (function () {
    const nonce = window.cspNonce;
    if (!nonce) return;
  
    const originalAppendChild = Element.prototype.appendChild;
  
    Element.prototype.appendChild = function <T extends Node>(el: T): T {
      if (el instanceof HTMLStyleElement || el instanceof HTMLScriptElement && !el.nonce) {
        el.setAttribute('nonce', nonce);
      }
      return originalAppendChild.call(this, el) as T;
    };
  
    console.log('[CSP] appendChild patched with nonce');
  })();
  export {};
  